// extracted by mini-css-extract-plugin
module.exports = {"vRed0":"#ff0000","wrap":"Icon_wrap__1gqt1","badge":"Icon_badge__1J_WD","notify":"Icon_notify__yr0vG"};